import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const PhotoGallery = ({ photos }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const openLightbox = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeLightbox = () => {
    setSelectedPhoto(null);
  };

  return (
    <section className="py-12 lg:py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Our Work in Action
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            See the impact of our volunteers and the communities we serve
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {photos?.map((photo) => (
            <div
              key={photo?.id}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all duration-300"
              onClick={() => openLightbox(photo)}
            >
              <Image
                src={photo?.image}
                alt={photo?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h4 className="text-white font-semibold mb-1">{photo?.title}</h4>
                  <p className="text-white/80 text-sm">{photo?.location}</p>
                </div>
                <div className="absolute top-4 right-4">
                  <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <Icon name="Maximize2" size={20} color="white" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedPhoto && (
          <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={closeLightbox}
          >
            <button
              className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-white/20 transition-colors"
              onClick={closeLightbox}
              aria-label="Close lightbox"
            >
              <Icon name="X" size={24} color="white" />
            </button>

            <div
              className="max-w-5xl w-full"
              onClick={(e) => e?.stopPropagation()}
            >
              <div className="aspect-[16/9] rounded-xl overflow-hidden mb-4">
                <Image
                  src={selectedPhoto?.image}
                  alt={selectedPhoto?.imageAlt}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="text-center text-white">
                <h3 className="text-2xl font-bold mb-2">{selectedPhoto?.title}</h3>
                <p className="text-white/80 mb-1">{selectedPhoto?.location}</p>
                <p className="text-sm text-white/60">{selectedPhoto?.date}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PhotoGallery;